module.exports = __webpack_public_path__ + "media/images/Icon-592e7d41.svg";